
import {
    SUBSCRIPTION_LISTING_REQUEST,
    SUBSCRIPTION_LISTING_SUCCESS,
    SUBSCRIPTION_LISTING_FAIL,
    DELETE_TEAM_REQUEST,
    DELETE_TEAM_SUCCESS,
    DELETE_TEAM_FAIL
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const SubscriptionAction = (data) => {
    console.log('team000-- ', data)
    return function (dispatch) {
        dispatch({
            type: SUBSCRIPTION_LISTING_REQUEST,
            payload: true,
        });

        let OPTION = {
            url: `${process.env.REACT_APP_API_PATH}/subscription_plan/get_all_subscription_plan?pageNumber=${data?.pageNumber}&pageSize=${data?.size}&status=${data.status}`,
            method: "GET",
            headers: {
                "content-type": "application/json",
            },
        };
        axios(OPTION)
            .then((res) => {
                dispatch(loadAllDetailsPre(res.data));
            })
            .catch((error) => {
                dispatch({
                    type: SUBSCRIPTION_LISTING_FAIL,
                    payload: false,
                    error: error,
                    msg: "Failed to load the information",
                });
            });
    };
};
const loadAllDetailsPre = (data) => {
    return {
        type: SUBSCRIPTION_LISTING_SUCCESS,
        result: data,
        payload: false,
        msg: "SUCCESS",
    };
};

export const DeleteTeamAction = (id) => {
    return function (dispatch) {
        dispatch({
            type: DELETE_TEAM_REQUEST,
            payload: true,
        });

        let OPTION = {
            url: `${process.env.REACT_APP_API_PATH}/ebench/soft_delete_teamMember?candidateId=${id}`,
            method: "DELETE",
            // data: id,
            headers: {
                "content-type": "application/json",
            },
        };

        axios(OPTION)
            .then((res) => {
                dispatch(deleteTeamsPre(res.data));
            })
            .catch((error) => {
                dispatch({
                    type: DELETE_TEAM_FAIL,
                    payload: false,
                    error: error,
                    msg: "Failed to load the information",
                });
            });
    };
};
export const deleteTeamsPre = (data) => {
    toast.success("Deleted Successfully!");
    setTimeout(() => {
        window.location.href = "/team-list";
    }, 2000)
    return {
        type: DELETE_TEAM_SUCCESS,
        result: data,
        payload: false,
        msg: "SUCCESS",
    };
};

